<template>
  <div>
    <div style="padding-top:10px;">
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="filteredRows"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-btn
              flat
              icon
              color="secondary"
              @click="NavigateToOrder(props.item.customerID)"
            >
              <v-icon>note_add</v-icon>
            </v-btn>
          </td>
          <td class="text-md-right">{{ props.item.ubAccountNo }}</td>
          <td class="text-md-justify">{{ props.item.firstName }}</td>
          <td class="text-md-right">{{ props.item.surname }}</td>
          <td class="text-md-right">
            {{
              props.item.company
                ? props.item.company
                : props.item.companyDetails
                ? props.item.companyDetails.companyName
                : "Residential"
            }}
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapOrderActions,
  mapMutations: mapOrderMutations
} = createNamespacedHelpers(`orders`);

export default {
  props: {
    customerData: { type: Array, required: true },
    orderType: { type: Number, required: true },
    loading: { type: Boolean, required: false }
  },
  computed: {
    filteredRows: function() {
      return this.customerData.filter(this.isValid);
    },
    companyName: function(item) {
      return item === null ? "" : item.companyName;
    }
  },
  data() {
    return {
      SearchText: null,
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        {
          text: "New Order",
          align: "left",
          sortable: false,
          value: "true"
        },
        {
          text: "Vonex Account no.",
          align: "right",
          sortable: true,
          value: "ubAccountNo"
        },
        {
          text: "First Name",
          align: "left",
          sortable: true,
          value: "firstName"
        },
        {
          text: "Surname",
          align: "right",
          sortable: true,
          value: "surname"
        },
        {
          text: "Company Name",
          align: "right",
          sortable: true,
          value: "true"
        }
      ]
    };
  },
  methods: {
    ...mapOrderState([
      "message",
      "company",
      "customer",
      "dealer",
      "isResidential"
    ]),
    ...mapOrderActions([
      "addOrder",
      "getOrder",
      "resetOrder",
      "listOrders",
      "removeOrder"
    ]),
    ...mapOrderMutations(["setResidential", "setExistingCust"]),
    isValid: function(customer) {
      let vm = this;
      if (vm.SearchText === null) return true;

      const filters = ["ubAccountNo", "firstName", "surname"];
      for (var i = 0; i < filters.length; i++) {
        if (typeof customer[filters[i]] == "undefined") return true;
        if (typeof customer[filters[i]] == "string") {
          if (
            customer[filters[i]]
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        } else {
          if (
            customer[filters[i]]
              .toString()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }

      /*
			if (
				customer.companyDetails !== null &&
				customer.companyDetails.companyName !== null
			) {
				if (
					customer.companyDetails.companyName
						.toUpperCase()
						.includes(vm.SearchText.toUpperCase())
				)
					return true;
			}
			*/

      if (typeof customer.companyDetails != "undefined") {
        if (
          customer.companyDetails !== null &&
          customer.companyDetails.companyName !== null
        ) {
          if (
            customer.companyDetails.companyName
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }

      return false;
    },
    NavigateToOrder: function(custID) {
      let vm = this;
      vm.dialog = false;

      vm.resetOrder()
        .then(() => {
          if (typeof vm.customerData.companyDetails != "undefined") {
            var company = vm.customerData.filter(x => x.customerID == custID)[0]
              .companyDetails;
            var orderType =
              company === null || company.companyName === null
                ? "Residential"
                : "Business";
          } else {
            var company = vm.customerData.company;
            var orderType = company === null ? "Residential" : "Business";
          }

          vm.setResidential(orderType !== "Business");
          let payload = { customerID: custID, type: vm.orderType };

          vm.addOrder(payload).then(data => {
            vm.setExistingCust();
            switch (data.orderType) {
              case 1:
                vm.$router.push({
                  path: "change-address"
                });

                break;
              case 2:
                vm.$router.push({
                  path: "change-lessee"
                });
                break;
              case 3:
                vm.$router.push({
                  path: "create-customer"
                });
                break;

              default:
                vm.$router.push({
                  path: "app-status"
                });
                break;
            }
          });

          /*					
					var company = vm.customerData.filter(x => x.customerID == custID)[0]
						.companyDetails;
					var orderType =
						company === null || company.companyName === null
							? "Residential"
							: "Business";
					*/
        })
        .catch(() => {});
    }
  }
};
</script>
<style></style>
